import { __decorate, __metadata } from "tslib";
import { action, observable } from 'mobx';
var ConnectionDetailsStore = (function () {
    function ConnectionDetailsStore(rootStore) {
        var _this = this;
        this.rootStore = rootStore;
        this.loading = true;
        this.connectionDetails = null;
        this.selectedPlanByType = {
            Business: '',
            Personal: '',
        };
        this.getInitialStoreState = function () { return ({
            formInitialValues: _this.getInitialFormValues(),
            formValues: null,
        }); };
        this.getInitialFormValues = function () { return ({
            nbnOrderType: '',
            nbnBoxAtPremises: '',
            startOrdering: true,
            nbnEslaService: false,
            medicalSecurityAlarm: false,
            priorityAssistance: false,
            provisioningCommencementDate: '',
        }); };
        this.connectionDetails = this.getInitialStoreState();
    }
    ConnectionDetailsStore.prototype.setPlanByType = function (type, code) {
        this.selectedPlanByType[type] = code;
    };
    ConnectionDetailsStore.prototype.setConnectionDetailsFromForm = function (details) {
        this.connectionDetails.formValues = details;
    };
    ConnectionDetailsStore.prototype.markLoading = function (loading) {
        this.loading = loading;
    };
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], ConnectionDetailsStore.prototype, "loading", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], ConnectionDetailsStore.prototype, "connectionDetails", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], ConnectionDetailsStore.prototype, "selectedPlanByType", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], ConnectionDetailsStore.prototype, "setPlanByType", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ConnectionDetailsStore.prototype, "setConnectionDetailsFromForm", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ConnectionDetailsStore.prototype, "markLoading", null);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], ConnectionDetailsStore.prototype, "getInitialStoreState", void 0);
    return ConnectionDetailsStore;
}());
export { ConnectionDetailsStore };
//# sourceMappingURL=ConnectionDetailsStore.js.map